import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ItemAvailabilityPhotoFragment = { __typename?: 'ItemAvailabilityPhotoData', photoId: string, photoUrl: string, recordedAt: Types.TDateISO, isPrimary: boolean };

export type GetItemLocationPhotosQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
  locationId: Types.Scalars['String']['input'];
}>;


export type GetItemLocationPhotosQuery = { __typename?: 'Query', itemLocationPhotos: Array<{ __typename?: 'ItemAvailabilityPhotoData', photoId: string, photoUrl: string, recordedAt: Types.TDateISO, isPrimary: boolean }> };

export type GetItemPhotosQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
}>;


export type GetItemPhotosQuery = { __typename?: 'Query', itemPhotos: Array<{ __typename?: 'ItemAvailabilityPhotoData', photoId: string, photoUrl: string, recordedAt: Types.TDateISO, isPrimary: boolean }> };

export const ItemAvailabilityPhotoFragmentDoc = new TypedDocumentString(`
    fragment ItemAvailabilityPhoto on ItemAvailabilityPhotoData {
  photoId
  photoUrl
  recordedAt
  isPrimary
}
    `, {"fragmentName":"ItemAvailabilityPhoto"});
export const GetItemLocationPhotosDocument = new TypedDocumentString(`
    query GetItemLocationPhotos($itemId: String!, $locationId: String!) {
  itemLocationPhotos(itemId: $itemId, locationId: $locationId) {
    ...ItemAvailabilityPhoto
  }
}
    fragment ItemAvailabilityPhoto on ItemAvailabilityPhotoData {
  photoId
  photoUrl
  recordedAt
  isPrimary
}`);
export const GetItemPhotosDocument = new TypedDocumentString(`
    query GetItemPhotos($itemId: String!) {
  itemPhotos(itemId: $itemId) {
    ...ItemAvailabilityPhoto
  }
}
    fragment ItemAvailabilityPhoto on ItemAvailabilityPhotoData {
  photoId
  photoUrl
  recordedAt
  isPrimary
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetItemLocationPhotos: build.query<GetItemLocationPhotosQuery, GetItemLocationPhotosQueryVariables>({
      query: (variables) => ({ document: GetItemLocationPhotosDocument, variables })
    }),
    GetItemPhotos: build.query<GetItemPhotosQuery, GetItemPhotosQueryVariables>({
      query: (variables) => ({ document: GetItemPhotosDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetItemLocationPhotosQuery, useLazyGetItemLocationPhotosQuery, useGetItemPhotosQuery, useLazyGetItemPhotosQuery } = injectedRtkApi;
